
import { Component, Mixins } from "vue-property-decorator";
import { IDrawableItem, AbstractCheckableItem } from "../../../../../domain/document/items";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";

@Component({
})
export default class CheckerPropertyEditableMixin extends Mixins() implements IDrawableItemEditable {
  editingSource: IDrawableItem;
  writeProperty: (write: (source: AbstractCheckableItem) => void) => void;

  get isMultiCheckable(): boolean {
    return (this.editingSource instanceof AbstractCheckableItem)
      ? this.editingSource.isMultiCheckable
      : undefined;
  }

  set isMultiCheckable(value: boolean) {
    this.writeProperty(s => s.isMultiCheckable = value);
  }
}
